(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/create-game/assets/javascripts/hooks/use-redirect-to.js') >= 0) return;  svs.modules.push('/components/marketplace/create-game/assets/javascripts/hooks/use-redirect-to.js');

'use strict';

const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const getTeamUrl = svs.components.marketplace.helpers.getTeamUrl;
const log = new svs.core.log.Logger('marketplace:client');
const useRedirectTo = () => {
  const history = useHistory();
  const validatedRedirect = (strategy, url, state) => {
    if (!history[strategy] && strategy) {
      log.info("Redirected with invalid strategy \"".concat(strategy, "\""));
      return history.push({
        pathname: url,
        state
      });
    }
    return history[strategy]({
      pathname: url,
      state
    });
  };
  const redirectToGame = function () {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      state = _ref.state,
      groupId = _ref.groupId,
      teamPathName = _ref.teamPathName,
      containerId = _ref.containerId,
      activatedDrawId = _ref.activatedDrawId,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'replace' : _ref$strategy;
    validatedRedirect(strategy, getTeamUrl(groupId, teamPathName.replace(/^-/, ''), 'spel', containerId, activatedDrawId), state);
  };
  const redirectToTeam = function () {
    let _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      groupId = _ref2.groupId,
      teamPathName = _ref2.teamPathName,
      _ref2$strategy = _ref2.strategy,
      strategy = _ref2$strategy === void 0 ? 'replace' : _ref2$strategy;
    const teamUrl = getTeamUrl(groupId, teamPathName.replace(/^-/, ''));
    validatedRedirect(strategy, teamUrl);
  };
  return {
    redirectToGame,
    redirectToTeam
  };
};
setGlobal('svs.components.marketplace.createGame.hooks.useRedirectTo', useRedirectTo);

 })(window);